var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 17V15H5.6L7.575 8.425C7.70833 7.99167 7.954 7.64567 8.312 7.387C8.67067 7.129 9.06667 7 9.5 7H12.5C12.9333 7 13.3293 7.129 13.688 7.387C14.046 7.64567 14.2917 7.99167 14.425 8.425L16.4 15H18V17H4ZM7.7 15H14.3L12.5 9H9.5L7.7 15ZM10 5V0H12V5H10ZM15.95 7.475L14.525 6.05L18.075 2.525L19.475 3.925L15.95 7.475ZM17 12V10H22V12H17ZM6.05 7.475L2.525 3.925L3.925 2.525L7.475 6.05L6.05 7.475ZM0 12V10H5V12H0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.a0e02f637ec093e548fa8ef0f397d60a.svg";
export { ForwardRef as ReactComponent };